function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { twMerge } from "@stereoagency/tailwind-config";
import React, { forwardRef, useState, useEffect } from "react";
function $CheckButton(_param, ref) {
    var _param_variant = _param.variant, variant = _param_variant === void 0 ? "primary" : _param_variant, _param_checked = _param.checked, checked = _param_checked === void 0 ? false : _param_checked, label = _param.label, children = _param.children, className = _param.className, _param_htmlType = _param.htmlType, htmlType = _param_htmlType === void 0 ? "button" : _param_htmlType, handleClick = _param.onClick, props = _object_without_properties(_param, [
        "variant",
        "checked",
        "label",
        "children",
        "className",
        "htmlType",
        "onClick"
    ]);
    var _useState = _sliced_to_array(useState(false), 2), isChecked = _useState[0], setIsChecked = _useState[1];
    useEffect(function() {
        setIsChecked(checked);
    }, [
        checked
    ]);
    var onClick = function() {
        if (handleClick) {
            handleClick();
        } else {
            setIsChecked(!isChecked);
        }
    };
    return /*#__PURE__*/ React.createElement("button", _object_spread({
        // eslint-disable-next-line
        type: htmlType,
        ref: ref,
        className: twMerge("isolate relative flex items-center font-heading font-semibold rounded-xl transition-all p-6 gap-x-4 w-full", "disabled:pointer-events-none disabled:opacity-50", "focus:outline focus:outline-4 focus:outline-fg-base", variant === "primary" && "bg-white text-black hover:bg-neutral-200 hover:border-button-main-bg-hover", variant === "secondary" && "bg-button-secondary-bg-base border-button-secondary-bg-base text-button-secondary-fg-base hover:bg-button-secondary-bg-hover hover:border-button-secondary-bg-hover", variant === "border" && "border border-button-bordered-border-base text-button-bordered-fg-base hover:border-button-bordered-border-hover", variant === "ghost" && "px-4 py-4 border-transparent text-button-ghost-fg-base hover:text-button-ghost-fg-hover", variant === "link" && "px-0 py-0 border-transparent text-button-ghost-fg-base hover:text-button-ghost-fg-hover", className),
        onClick: onClick
    }, props), /*#__PURE__*/ React.createElement("span", {
        className: twMerge("w-5 h-5 border-2 border-red-500 rounded-full", isChecked ? "bg-red-500" : "bg-transparent")
    }), !!(children || label) && /*#__PURE__*/ React.createElement("span", null, children || label));
}
var CheckButton = /*#__PURE__*/ forwardRef($CheckButton);
export default CheckButton;

//# sourceMappingURL=CheckButton.js.map